import { useCurrentUser } from "@/hooks/useCurrentUser";

/**
 * Returns a stable permission-check function derived from the current user's
 * permissions array returned by the API (mirrors Blazor UserPermissionService.HasPermission).
 *
 * All permission key constants live in AppPermissions.cs; the same strings are
 * used here so the mapping is exact.
 */
export function usePermissions() {
  const user = useCurrentUser();
  const permissions: readonly string[] = user?.permissions ?? [];

  function hasPermission(key: string): boolean {
    return permissions.includes(key);
  }

  return { hasPermission, permissions };
}

// ─── Named permission booleans for common checks ──────────────────────────────

export function useCanAddMeeting() {
  const { hasPermission } = usePermissions();
  return hasPermission("CanAddMeeting");
}

export function useCanEditMeeting() {
  const { hasPermission } = usePermissions();
  return hasPermission("CanEditMeeting");
}

export function useCanPerformBulkAction() {
  const { hasPermission } = usePermissions();
  return hasPermission("CanPerformBulkAction");
}

export function useCanViewToggleSettings() {
  const { hasPermission } = usePermissions();
  return hasPermission("CanViewToggleSettings");
}

export function useCanSubmitToApprover() {
  const { hasPermission } = usePermissions();
  return hasPermission("CanSubmitToApprover");
}

export function useCanExportGRCReport() {
  const { hasPermission } = usePermissions();
  return hasPermission("CanExportGRCReport");
}
